module.exports = __webpack_public_path__ + "static/images/img-border.49fa347.png";